import React from 'react';
import {Switch} from "react-router-dom";
import {Affix, Layout} from "antd";
import PropTypes from 'prop-types';

import './baseLayout.scss';

BaseLayout.propTypes = {
    children: PropTypes.node,
    logoSection: PropTypes.node,
    actionBar: PropTypes.node,
    class: PropTypes.string
};

function BaseLayout(props) {
    const { Content, Header } = Layout;
    const { children, logoSection, actionBar = false, className = '',  } = props;
    return (
        <Layout className={`Base-layout ${className}`}>
            <Affix style={{ zIndex: 999}}>
                <Header>
                    {logoSection}
                    { actionBar ? actionBar : ''}
                </Header>
            </Affix>


            <Content>
                <Switch>
                    { children }
                </Switch>

            </Content>
        </Layout>
    )
}

export default BaseLayout;
